<div
  class="ubf-container-fields"
  [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      placeholder="Fondo (UBFP)"
      formControlName="UBFP">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Collocazione (UBFC)"
      formControlName="UBFC">
  </mat-form-field>
</div>